import { FC } from 'react';

import dayjs from 'dayjs';

import TableCell from '@mui/material/TableCell';

import css from './UserDateColumn.module.css';

interface UserDateColumnProps {
  user: string;
  date: string;
}

export const UserDateColumn: FC<UserDateColumnProps> = ({ user, date }) => (
  <TableCell align="right">
    <p className={css.userDateColumnUser}>{user}</p>

    <p className={css.userDateColumnDate}>{dayjs(date).format('DD.MM.YYYY HH:mm')}</p>
  </TableCell>
);
